var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.$t('components.activate')))]),(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }